module.exports = __webpack_public_path__ + "img/tarot-major-arcana-14.39147c17.png";